// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-identity-lifecycle.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-identity-lifecycle',
  title: 'Maintain a documented identity lifecycle with unique identities for all users',
  description:
    'The organisation must have a documented identity lifecycle that covers creation, modification and deprovisioning of identities. All users, their logins and their actions in systems must be identifiable through a unique identity. Shared or generic accounts must not be used where individual accountability is required.',
  category: 'access',
  scfIds: ['SCF-IAM-002', 'SCF-IAM-006'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Identity lifecycle procedure is published' },
    { type: 'document-approved', description: 'Procedure has been approved' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
